import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AITariff, AITariffType } from '@proto/odoo/order';
import { AiTariffService } from 'src/app/ai-tariff.service';

@Component({
  selector: 'app-ai-tariff-select',
  templateUrl: './ai-tariff-select.component.html',
  standalone: false
})
export class AiTariffSelectComponent {

  @Input() public currentPlan: AITariff;
  @Input() public aiTariffs: AITariff[];

  @Output()
  public back = new EventEmitter<void>();
  @Output()
  public selected = new EventEmitter<string>();

  protected readonly AITariffType = AITariffType;

  constructor(public aiTariffService: AiTariffService) { }

  protected get columnClass(): string {
    switch (this.aiTariffs?.length) {
      case 1: return 'col-12';
      case 2: return 'col-12 col-md-6';
      case 3: return 'col-12 col-md-4';
      case 4: return 'col-12 col-md-3';
      default: return 'col-12 col-md-4';
    }
  }

  public onBack() {
    this.back.emit();
  }

  public onAITariffSelected(aiTariff: string) {
    this.selected.emit(aiTariff);
  }

}
